const BackgroundGradient = () => (
  <div className={'w-[200%] z-0 h-full flex items-center justify-center absolute top-0 lg:top-1/2 left-1/2 transform -translate-x-1/2 lg:-translate-y-1/2 rotate-45 lg:rotate-[35deg]'}>
    <div className={'bg-gradient-to-tr animate-float from-primary/20 to-highlight/20 w-full h-[250px] rounded-[100%] blur-3xl'}/>
  </div>
);

export default BackgroundGradient